// Vendors
import React, { useState } from 'react';

const ProjectMessage = ({
  IS_ADMIN,
  messages,
  builder,
  new_comments,
  title,
  pid,
  url,
  loading,
  commentTabIDOpen,
  setCommentTabIDOpen,
  handleMarkAsRead,
  postNewMessage
}) => {
  const [open, setOpen] = useState();
  const [showPostNewMessage, setShowPostNewMessage] = useState(false);
  const [newMessage, setNewMessage] = useState('');
  const [newMessageCount, setNewMessageCount] = useState(new_comments);

  const handleGoToBuildersProjects = (event, uid) => {
    event.preventDefault();

    localStorage.setItem(
      'adminFilters',
      JSON.stringify({
        status: '',
        builder: uid,
        state: ''
      })
    );

    window.location = event.currentTarget.href;
  };

  return (
    <div className="u--display-block u--margin-bottom-20">
      <button
        className={`btn btn--white btn--pip-accordion module-hover-root ${
          commentTabIDOpen === pid ? 'btn--pip-accordion--on' : ''
        } ${title > 100 ? 'btn--md' : 'btn--lg'}`}
        type="button"
        onClick={() => {
          setCommentTabIDOpen(commentTabIDOpen === pid ? 0 : pid);
          setOpen(!open);
        }}
      >
        <span className="btn__content">
          <span className="btn__text">
            {title !== '' ? title : '--'}{' '}
            {newMessageCount > 0 && (
              <span className="btn__text--message-count">
                {newMessageCount}
              </span>
            )}
          </span>
          <span className="btn__arrow"></span>
        </span>
      </button>

      <div
        className={
          commentTabIDOpen === pid
            ? 'u--display-block u--padding-top-20 u--squash-end u--padding-bottom-10'
            : 'u--display-none'
        }
      >
        <div className="direct-message__container">
          <div className="direct-message__toggle-btn">
            <button
              className={`btn btn--gold ${
                showPostNewMessage
                  ? 'u--display-none'
                  : 'u--display-inline-block'
              }`}
              type="button"
              onClick={() => setShowPostNewMessage(!showPostNewMessage)}
            >
              <span className="btn__content">
                <span className="btn__text">Post New Message</span>
              </span>
            </button>
          </div>

          <div className="direct-message__mark-as-read u--text-align-center">
            {newMessageCount > 0 && (
              <button
                type="button"
                className="btn btn--link module-hover-root"
                onClick={() => {
                  handleMarkAsRead(pid);
                  setNewMessageCount(0); //stupid that this is necessary
                }}
              >
                <span className="btn__content">
                  <span className="btn__text">Mark as read</span>
                </span>
              </button>
            )}
          </div>

          {IS_ADMIN && (
            <div className="direct-message__project-link">
              <a
                href={url}
                title={title}
                className="btn btn--link btn--sm btn--has-arrow module-hover-root"
              >
                <span className="btn__content">
                  <span className="btn__text u--color-black">
                    Go to project page
                  </span>
                  <span className="btn__arrow arrow"></span>
                </span>
              </a>
              <br />
              <a
                href="/pcip/dashboard/"
                title="Go to Builder's Projects"
                className="btn btn--link btn--sm btn--has-arrow module-hover-root"
                onClick={(event) =>
                  handleGoToBuildersProjects(event, builder.ID)
                }
              >
                <span className="btn__content">
                  <span className="btn__text u--color-black">
                    Go to{' '}
                    {builder.display_name ? builder.display_name : 'builder'}'s
                    projects
                  </span>
                  <span className="btn__arrow arrow"></span>
                </span>
              </a>
            </div>
          )}

          {showPostNewMessage === true && (
            <div className="direct-message__new-comment">
              <div
                className="form__field u--margin-bottom-30"
                style={{
                  maxWidth: '600px',
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }}
              >
                <textarea
                  type="textarea"
                  className="form__textarea form__textarea--no-shadow u--margin-bottom-20"
                  value={newMessage}
                  onChange={(event) => setNewMessage(event.target.value)}
                />
                <button
                  className={`u--margin-right-10 btn btn--gold ${
                    loading ? 'btn--loading' : ''
                  }`}
                  type="button"
                  disabled={!newMessage}
                  onClick={() => postNewMessage(newMessage, pid)}
                >
                  <span className="btn__content">
                    <span className="btn__text">Post New Message</span>
                  </span>
                </button>
                <button
                  className="btn btn--red btn--outline"
                  type="button"
                  onClick={() => setShowPostNewMessage(!showPostNewMessage)}
                >
                  <span className="btn__content">
                    <span className="btn__text">Hide</span>
                  </span>
                </button>
              </div>
            </div>
          )}
          <div className="direct-message__messages-list">
            {messages.map(
              (
                {
                  comment_is_new,
                  comment_by_builder,
                  comment_date,
                  comment_author,
                  comment_content,
                  user_id
                },
                index
              ) => (
                <div
                  key={index}
                  className={`message${
                    comment_is_new == 1 ? ' message--is-new' : ''
                  }${comment_by_builder == 1 ? ' message--mine' : ''}`}
                  style={{ marginLeft: 'auto', marginRight: 'auto' }}
                >
                  <div className="message__meta">
                    <h5 className="message__date">
                      {comment_is_new == 1 ? (
                        <span className="message__date--new">NEW — </span>
                      ) : (
                        ''
                      )}
                      {comment_date}
                    </h5>
                    <h5 className="message__author">
                      {comment_by_builder == 1 ? comment_author : 'PERC Admin'}
                    </h5>
                  </div>
                  <p
                    className="message__content"
                    dangerouslySetInnerHTML={{ __html: comment_content }}
                  />
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectMessage;
